/* eslint-disable import/no-mutable-exports */
import React, { useContext } from 'react';
import styles from './DialogNode.module.css';
import Select from '../../@base/Select';
import { getFullPathFolder } from './Commons';

import ContextWatson from '../../../context/WatsonContext';
import SelectOption from '../../@base/SelectOption';
import { WATSON_DIALOG_NEXT_STEP_SELECTOR } from '../../../dto/DialogNextStepDTO';

const DialogoNodeNextStepController = (props) => {
  const watsonContext = useContext(ContextWatson);
  const dialogsFromContext = { ...watsonContext.dialogs };

  const { selectedDialog } = props;
  const { watsonNameInstance } = props;
  const { nextStep } = props;

  if (!nextStep) return null;

  const getPathFolder = (
    folder,
  ) => getFullPathFolder(folder, watsonNameInstance, dialogsFromContext);

  const dialogs = Object.values(dialogsFromContext)
    .filter((e) => e.type !== 'folder' && e.id !== selectedDialog)
    .map((e) => ({ ...e, title: getPathFolder(e) }));
  const selectDialogListSelected = dialogs.find((e) => e.id === nextStep.dialog) || { title: '', id: '' };
  const selectDialogValue = selectDialogListSelected.title;
  const selectDialogOptions = dialogs.map(
    (i) => {
      const value = i.title || i.untitlePlaceholder;
      return (
        <SelectOption key={i.id} selected={i.id === selectDialogListSelected.id} title={value}>
          {value}
        </SelectOption>
      );
    },
  );

  const selectDialogOnChangeHandler = (e) => {
    if (selectDialogValue !== e) {
      const selected = dialogs.find((o) => (o.title === e || o.untitlePlaceholder === e));
      props.save({ ...nextStep, dialog: selected.id });
    }
  };

  const selectors = Object.values(WATSON_DIALOG_NEXT_STEP_SELECTOR);
  const selectWhenValue = nextStep.selector;
  const selectWhenOptions = selectors.map(
    (value) => (
      <SelectOption key={value} selected={value === selectWhenValue} title={value}>
        {value}
      </SelectOption>
    ),
  );

  const selectWhenOnChangeHandler = (e) => {
    if (selectWhenValue !== e) {
      props.save({ ...nextStep, selector: e });
    }
  };

  return (
    <div className={styles.ComponentSubList} style={{ textAlign: 'left' }}>
      <div className="item-list mb-3">
        <div>
          <Select
            inline
            small
            labelWidth={60}
            label="Diálogo"
            placeholder="Selecione"
            classes={styles.IntentSelect}
            disabled={props.disabled}
            value={selectDialogValue}
            onChange={selectDialogOnChangeHandler}
          >
            {selectDialogOptions}
          </Select>
        </div>
      </div>

      <div className="item-list mb-3">
        <div>
          <Select
            inline
            small
            labelWidth={60}
            label="Quando"
            placeholder="Selecione"
            classes={styles.IntentSelect}
            value={selectWhenValue}
            disabled={props.disabled || selectDialogValue === ''}
            onChange={selectWhenOnChangeHandler}
          >
            {selectWhenOptions}
          </Select>
        </div>
      </div>

    </div>
  );
};

export default DialogoNodeNextStepController;
